'use strict';
exports.__esModule = true;
exports.default = {
  bu_ran: '不然',
  unit_cup: '单位:杯',
  shi_xian_chui_zhi_ju_zhong: '实现垂直居中',
  zhang_dan_jin_e: '账单金额',
  jin_e: '金额',
  jie_bang: '解绑',
  qing_shu_ru_tui_kuan_zheng_shu: '请输入退款证书',
  dao_chu_shi_jian_qu_jian: '导出时间区间',
  qing_she_ding_she_bei_suo_zai_wei_zhi: '请设定设备所在位置',
  ji_fei_she_bei_zong_shu: '计费设备总数',
  yi_xuan_she_bei: '已选设备',
  ding_dan_shan_chu: '订单删除',
  qing_shu_ru_shou_quan_mi_yao: '请输入授权密钥',
  wei_xin_pu_tong_shang_hu: '微信普通商户',
  yi_chang_ming_cheng: '异常名称',
  tai: '台',
  wei_xin_zhi_fu: '微信支付',
  dian_ji_zu_zhi_jia_gou_cha_kan_geng_duo_xin_xi: '点击组织架构查看更多信息',
  dian: '点',
  yue_xiao_yue_kao_qian: '越小越靠前',
  zhang_qi: '账期',
  qing_shu_ru_cheng_yuan_shou_ji: '请输入成员手机',
  tui_kuan_cheng_gong: '退款成功',
  chong_pao_qi_wei_an_zhuang_dao_wei: '冲泡器未安装到位',
  la_qu_she_bei_yin_pin: '拉取设备饮品',
  jie_shu_shi_jian: '结束时间',
  ben_yue_xiao_shou_e: '本月销售额',
  deng_dai_xi_tong_wan_cheng_she_bei_yin_pin_du_qu: '等待系统完成设备饮品读取',
  qing_shu_ru_dao_ru_she_bei_bian_hao: '请输入导入设备编号',
  ding_dan_fen_bu: '订单分布',
  suo_shu_fen_zu: '所属分组',
  she_bei_can_shu_yi_ying_yong: '设备参数已应用',
  bian_ji_cheng_yuan: '编辑成员',
  pei_zhi_zhi_fu_zhi_qian_qing_xian_zai_zhi_fu_bao_shang_hu_hou_tai_pei_zhi_zhi_fu_wang_ye_xin_xi: '配置支付之前请先在支付宝商户后台配置支付网页信息',
  she_bei_bian_hao: '设备编号',
  xuan_qu_dao_chu_shu_ju: '选取导出数据',
  pei_fang_yin_pin_bu_yun_xu_xin_zeng: '配方饮品不允许新增',
  zhi_zuo_lei_xing: '制作类型',
  zhi_zuo_zhuang_tai: '制作状态',
  zu_zhi_jia_gou: '组织架构',
  shang_yue: '上月',
  ben_yue_xiao_shou_ding_dan: '本月销售订单',
  chu_shi_zhuang_tai: '初始状态',
  bian_ji_xin_xi: '编辑信息',
  shan_chu_zhi_fu: '删除支付',
  bei_zhu: '备注',
  chan_pin_xing_hao: '产品型号',
  dian_re_pan_gong_shui_yi_chang: '电热盘供水异常',
  kai_shi_ri_qi: '开始日期',
  yu_shang_yue_dui_bi_bei_liang_qing_kuang: '与上月对比杯量情况',
  she_bei_ji_fei_zhong_zhi_zhou_qi: '设备计费重置周期',
  dai_ji_ping_bao_bian_ji: '待机屏保编辑',
  ce_shi_ding_dan: '测试订单',
  xin_zeng_cheng_yuan: '新增成员',
  jiao_se_mo_kuai: '角色模块',
  xuan_qu_yin_pin: '选取饮品',
  cha_kan_xiang_qing: '查看详情',
  qi_dong: '启动LOGO',
  dui_bi_tong_ji: '对比统计',
  fen_zu_dui_bi: '分组对比',
  qing_xuan_ze_zhi_zuo_lei_xing: '请选择制作类型',
  guan_jian_zheng_ming_cheng: '关键帧名称',
  chong_pao_qi_qing_jie: '冲泡器清洁',
  wei_hu_ming_cheng: '维护名称',
  zhe_li_kong_kong_ru_ye: '这里空空如也',
  jiang_wen_jian_tuo_dao_ci_chu: '将文件拖到此处',
  qing_shu_ru_yin_pin_ming_cheng: '请输入饮品名称',
  can_shu_shuo_ming: '参数说明',
  ci_cao_zuo_jiang_tong_bu_yin_pin_zhi_she_bei: '此操作将同步饮品至设备, 是否继续?',
  shang_chuan_dai_ji_ping_bao: '上传待机屏保',
  yi_tui_kuan: '已退款',
  cha_kan_she_bei: '查看设备',
  shi_fou_ji_xu_shan_chu: '是否继续删除',
  she_bei_yin_pin_geng_xin: '设备饮品更新',
  qi_shi_shi_jian: '起始时间',
  ci_cao_zuo_jiang_hui_tui_hai_ding_dan_jin_e: '此操作将会退还订单金额',
  wu_xiao_zhi_fu: '无效支付',
  shou_ji_jian_ce: '手机检测',
  mo_ren_wei_zhi_xian: '默认为直线',
  qing_tian_xie_wan_zheng_xin_xi: '请填写完整信息',
  ti_shi_wen_zi: '提示文字',
  she_bei_he_ji: '设备合计',
  wei_xin_nei_wu_fa_shi_yong_zhi_fu_bao_zhi_fu: '微信内无法使用支付宝支付',
  jin_ri_ding_dan_shu: '今日订单数',
  yin_pin_can_shu_shang_chuan: '饮品参数上传',
  she_bei_yin_pin_tui_song_zhong: '设备饮品推送中，请耐心等待',
  zhong_zhi_she_bei_fei_yong: '重置设备费用',
  qing_shu_ru_dui_ying_de_chan_pin: '请输入对应的产品',
  qing_shu_ru_shou_ji_hao_ma: '请输入手机号码',
  pai_xu_wei_zhi: '排序位置',
  bao_cun_pei_zhi: '保存配置',
  bao_cun_she_zhi: '保存设置',
  yi_bang_ding_she_bei: '已绑定设备',
  shi_shi_she_bei_shu: '实时设备数',
  xuan_qu_dao_chu_shi_jian_duan: '选取导出时间段',
  qing_shu_ru: '请输入',
  shi_jian_wei_du: '时间维度',
  chong_zhu_xi_tong_yi_chang: '冲煮系统异常',
  jin_ri_xiao_shou_e: '今日销售额',
  xin_zeng_fen_zu: '新增分组',
  shan_chu_fen_zu: '删除分组',
  xiang_guan_she_bei: '相关设备',
  zhi_zuo_guo_cheng_zhan_shi_tu: '制作过程展示图',
  pei_zhi_zhi_fu_zhi_qian_qing_xian_zai_wei_xin_shang_hu_hou_tai_pei_zhi_zhi_fu_wang_ye_xin_xi: '配置支付之前请先在微信商户后台配置支付网页信息',
  qing_xuan_qu_xu_yao_dao_chu_de_shu_ju: '请选取需要导出的数据',
  zhi_zuo_qing_dan: '制作清单',
  xiao_bei: '小杯',
  mo_dou_ji_yi_chang: '磨豆机异常',
  shang_chuan_hou_li_ji_xiu_gai_shi_pin: '上传后立即修改视频',
  ke_xuan_wei: '可选为',
  jie_shu_ri_qi: '结束日期',
  dian_ji_cha_kan_geng_duo_shuo_ming: '点击查看更多说明',
  qing_dao_ru_shou_quan_zheng_shu: '请导入授权证书，如果不进行退款则不需要',
  shan_chu: '删除',
  guan_bi_quan_xian: '关闭权限',
  yue: '月',
  da_bei: '大杯',
  chuang_jian_cheng_gong: '创建成功',
  ben_zhou_xiao_shou_e: '本周销售额',
  dang_qian_gong_neng_zan_wei_kai_fang: '当前功能暂未开放',
  ji_shu_zhu_li_shang_ye_fa_zhan: '技术助力商业发展',
  ci_cao_zuo_jiang_shan_chu_yin_pin_pei_fang: '此操作将删除饮品配方, 是否继续?',
  she_bei_shu: '设备数',
  xuan_qu_xu_yao_tong_bu_she_bei_hou: '选取需要同步设备后，点击同步即可',
  fen_ge: '分隔',
  zhi_fu_bao_pu_tong_shang_hu: '支付宝普通商户',
  yi_bang_ding_jiao_se_yong_hu: '已绑定角色用户',
  bao_yang_fen_xi: '保养分析',
  she_bei_yin_pin: '设备饮品',
  qing_xuan_qu_xu_yao_dao_chu_de_fen_zu_huo_she_bei: '请选取需要导出的分组或设备',
  zui_jin_yi_ci_zhong_zhi_shi_jian: '最近一次重置时间',
  wen_du_guo_gao: '温度过高',
  yi_chang: '异常',
  wang_ji_mi_ma: '忘记密码',
  dan_wei_wei_yuan: '单位为元，支持小数点后两位',
  ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_zhi_yun_duan: '此操作将全量拉取设备饮品至云端,是否继续',
  zhang_qi_shi_jian: '账期时间',
  tou_xiang: '头像',
  bing_xiang_tong_xin_yi_chang: '冰箱通信异常',
  she_bei_zhi_zuo_bei_shu: '设备制作杯数',
  zhi: '至',
  tong_xin_yi_chang: '通信异常',
  yin_pin_zhi_zuo_bei_shu: '饮品制作杯数',
  ding_dan_tui_kuan: '订单退款',
  dai_wei_xiu: '待维修',
  suo_you_fen_zu: '所有分组',
  yi_guan_bi_quan_xian: '已关闭权限',
  wei_guan_bi_quan_xian: '未关闭权限',
  qing_shu_ru_guan_bi_quan_xian_ming_cheng: '请输入关闭权限名称',
  yun_ying_shu_ju: '运营数据',
  yi_chang_ci_shu_zong_ji: '异常次数总计',
  bian_ji: '编辑',
  qing_shu_ru_shang_chuan_she_bei_bian_hao: '请输入上传设备编号',
  wei_hu_she_zhi: '维护设置',
  jiao_ban_qi_qing_xi: '搅拌器清洗',
  tui_kuan_zhuang_tai: '退款状态',
  jiao_yi_shou_xu_fei_you_wei_xin_shou_qu: '交易手续费由微信收取',
  wang_ye_quan_ping: '网页全屏',
  ru_guo_shi_quan_ping: '如果是全屏',
  dong_hua_bo_fang_de_ci_shu: '动画播放的次数',
  xin_zeng_cao_zuo_shuo_ming: '新增操作说明',
  jiao_yi_shou_xu_fei_you_zhi_fu_bao_shou_qu: '交易手续费由支付宝收取',
  deng_lu: '登录',
  xuan_qu_suo_xu_dao_chu_fen_zu: '选取所需导出分组',
  shi_jian_qu_jian: '时间区间',
  zui_jin_san_ge_yue: '最近三个月',
  qing_xuan_ze_suo_shu_fen_zu: '请选择所属分组',
  cheng_yuan_fen_zu: '成员分组',
  xia_yi_bu: '下一步',
  xin_xi_geng_xin: '信息更新',
  zhi_fu_bao: '支付宝',
  zhi_fu_bao_nei_wu_fa_shi_yong_wei_xin_zhi_fu: '支付宝内无法使用微信支付',
  xin_zeng_cheng_gong: '新增成功',
  ben_zhou_xiao_shou_ding_dan: '本周销售订单',
  she_bei_zhou_qi_fei_yong_shang_xian: '设备周期费用上限',
  qing_shu_ru_yin_pin_ying_wen_ming_cheng: '请输入饮品英文名称',
  ding_dan_zhuang_tai: '订单状态',
  zi_jin_jie_suan_zhi_zhi_fu_bao_shang_hu: '资金结算至支付宝商户',
  huo: '或',
  fei_yong_zhang_dan: '费用账单',
  ci_cao_zuo_jiang_yi_chu_cheng_yuan: '此操作将移除成员, 是否继续',
  shang_hu: '商户',
  chong_zhu_xi_tong_qing_xi: '冲煮系统清洗',
  yi_chang_fen_xi: '异常分析',
  gao_jing_ming_cheng: '告警名称',
  ci_cao_zuo_jiang_shan_chu_she_bei_zhi_zuo_tu_pian: '此操作将删除设备制作图片',
  zhi_zuo_zhong: '制作中',
  ci_cao_zuo_jiang_yi_chu_she_bei_yu_bu_men_guan_xi: '此操作将移除设备与部门关系, 是否继续',
  qing_que_bao_xuan_qu_she_bei_zai_xian: '请确保选取设备在线',
  can_shu_pei_zhi: '参数配置',
  nian: '年',
  zhi_zuo_guo_cheng_shi_pin: '制作过程视频',
  qing_dao_ru_shou_quan_mi_yao: '请导入授权密钥，如果不进行退款则不需要',
  qing_shu_ru_shang_hu_mi_yao: '请输入商户密钥',
  zhi_zuo_fang_shi_fen_bu: '制作方式分布',
  zhu_ce_shi_jian: '注册时间',
  qu_xiao: '取消',
  zhi_zuo_shi_pin_bian_ji: '制作视频编辑',
  qing_shu_ru_she_bei_bian_ma: '请输入设备编码',
  she_bei_bao_yang_fen_bu: '设备保养分布',
  mo_ren_hui_fan_hui: '默认会返回',
  xiao_bei_jia_ge: '小杯价格',
  xiang_guan_mo_kuai: '相关模块',
  qing_lian_xi_guan_li_yuan_kai_tong_quan_xian: '请联系管理员开通权限',
  yi_chang_ming_xi: '异常明细',
  xiu_gai_yin_pin_ke_tong_guo_pi_liang_ding_jia_chu_jin_xing_xiu_gai: '修改饮品可通过批量定价处进行修改',
  she_bei_bang_ding_cheng_gong: '设备绑定成功',
  loading_success: '信息加载成功',
  rename_device: '支付重命名',
  guan_bi: '关闭',
  fan_hui: '返回',
  dao_ru_cheng_gong: '导入成功',
  gong_zhong_hao: '公众号',
  qing_shu_ru_shang_hu: '请输入商户',
  fei_zhi_fu_ding_dan: '非支付订单',
  qing_xuan_qu_jie_shu_gong_zuo_shi_jian: '请选取结束工作时间',
  bian_ji_ping_bao: '编辑屏保',
  shou_quan_gong_yao: '授权公钥',
  shan_chu_jiao_se_jiang_dao_zhi_yong_hu_wu_fa_zheng_chang_shi_yong_xi_tong_gong_neng: '删除角色将导致用户无法正常使用系统功能',
  she_bei_ming_cheng: '设备名称',
  xin_zeng_yin_pin_pei_fang: '新增饮品配方',
  bian_ji_cheng_gong: '编辑成功',
  shou_quan_mi_yao: '授权密钥',
  cao_zuo: '操作',
  wei_hu_shu_ju: '维护数据',
  tian: '天',
  ping_bao_tu_pian_zui_shao_yi_zhang: '屏保图片最少一张',
  ben_yue_ding_dan_shu: '本月订单数',
  zhi_fu_fang_shi_fen_bu: '支付方式分布',
  zheng_zai_huo_qu_she_bei_yin_pin: '正在获取设备饮品,请耐心等待',
  ci_cao_zuo_jiang_shan_chu_she_bei: '此操作将删除设备',
  bang_ding_shi_jian: '绑定时间',
  ben_zhou_ding_dan_shu: '本周订单数',
  yi_xuan_fen_zu: '已选分组',
  yin_pin_shu_ju: '饮品数据',
  bang_ding_she_bei: '绑定设备',
  shang_hu_hao: '商户号',
  re_shui_guo_lu_gong_shui_yi_chang: '热水锅炉供水异常',
  yin_pin_bang_dan: '饮品榜单',
  zui_jin_yi_ge_yue: '最近一个月',
  ji_fei_shi_jian: '计费时间',
  shang_chuan_hou_li_ji_xiu_gai: '上传后立即修改',
  xuan_qu_ri_qi: '选取日期',
  qing_shu_ru_shou_quan_gong_yao: '请输入授权公钥',
  shi_xu_yao_bang_ding_dao_xuan_ze_qi_de_guan_jian_zheng_ming_cheng: '是需要绑定到选择器的关键帧名称',
  qing_shu_ru_fen_zu_ming_cheng: '请输入分组名称',
  zheng_qi_dian_re_pan: '蒸汽电热盘',
  ding_dan_gai_kuang: '订单概况',
  zhi_fu_jin_e: '支付金额',
  qing_tian_ru_shou_quan_gong_yao: '请填入授权公钥',
  qing_xuan_qu_xu_yao_tui_song_de_she_bei: '请选取需要推送的设备',
  she_bei_xin_xi: '设备信息',
  yin_pin_lie_biao: '饮品列表',
  geng_duo_pei_zhi: '更多配置',
  xiu_gai_cheng_gong: '修改成功',
  dang_tian: '当天',
  zhi_fu_ding_dan: '支付订单',
  all: '全部',
  make_success: '制作成功',
  make_fail: '制作失败',
  shang_chuan_shi_bai: '上传失败',
  shi_fou_ji_xu: '是否继续',
  shi_jian_fan_wei: '时间范围',
  zui_jin_yi_nian: '最近一年',
  yi_zhi_fu: '已支付',
  xin_zeng_jiao_se: '新增角色',
  suo_shu_chan_pin: '所属产品',
  dai_wei_hu: '待维护',
  bao_cun_ping_bao: '保存屏保',
  yin_pin_xin_xi_yi_xia_fa: '饮品信息已下发',
  zui_xiao_de_shan_qu_jiao_du: '最小的扇区角度',
  de_li_wei_zhi: '地理位置',
  zhuang_tai: '状态',
  tian_jia_cheng_gong: '添加成功',
  an_quan_tui_chu: '安全退出',
  shang_yi_bu: '上一步',
  suo_you_zhi_fu: '所有支付',
  zhi_zuo_shi_bai: '制作失败',
  xuan_qu_gong_si: '选取公司',
  wei_hu_xin_xi_bian_ji: '维护信息编辑',
  gong_zuo_shi_jian: '工作时间',
  mo_dou_xiao_yan: '磨豆校验',
  mi_ma_deng_lu: '密码登录',
  sheng_yu_fei_yong_e_du: '剩余费用额度',
  jin_san_shi_tian_cheng_jiao: '近三十天成交',
  dong_hua_de_su_du_qu_xian: '动画的速度曲线',
  yi_chang_gao_jing: '异常告警',
  shi_xian_shui_ping_ju_zhong: '实现水平居中',
  deng_lu_mi_ma: '登录密码',
  bang_ding_cheng_yuan: '绑定成员',
  yi_chang_zhan_bi: '异常占比',
  fen_liao_he_wei_an_zhuang_dao_wei: '粉料盒未安装到位',
  da_bei_jia_ge: '大杯价格',
  fen_pei_she_bei: '分配设备',
  jiao_se_ming_cheng: '角色名称',
  bian_ji_yin_pin: '编辑饮品',
  yi_chu_cheng_gong: '移除成功',
  jie_zhi_jin_ri: '截止今日',
  ti_shi: '提示',
  edit_department_name: '请输入部门名称',
  qing_xuan_ze_she_bei_zhuang_tai: '请选择设备状态',
  ren_wu_bian_hao: '任务编号',
  ri: '日',
  yi_chang_lei_xing: '异常类型',
  zi_ding_yi_xin_zeng: '自定义新增',
  dai_ji_ping_bao: '待机屏保',
  li_xian: '离线',
  zhong_zhi_e_du_zhou_qi: '重置额度周期',
  wu_zhi_fu_ding_dan: '无支付订单',
  jiao_se_xin_xi: '角色信息',
  xi_tong_ya_li_guo_da: '系统压力过大',
  ke_tong_guo_ye_mian_jin_xing_tian_jia_cao_zuo: '可通过页面进行添加操作',
  zhong_bei: '中杯',
  qing_shu_ru_zhi_fu_ming_cheng: '请输入支付名称',
  shu_ju_dao_chu: '数据导出',
  zhi_zuo_tu_pian_bian_ji: '制作图片编辑',
  xiao_shou_e: '销售额',
  wu_zhi_fu: '无支付',
  qing_shu_ru_yuan_gong_ming_cheng: '请输入员工名称',
  zheng_chang_yun_xing: '正常运行',
  qing_shu_ru_deng_lu_mi_ma: '请输入登录密码',
  qing_shu_ru_yan_zheng_ma: '请输入图形验证码',
  qing_shu_ru_wei_hu_ming_cheng: '请输入维护名称',
  xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce: '限制分辨率参考机型分辨率手册',
  quan_bu_mo_kuai: '全部模块',
  huo_qu_qi_ye_bian_hao: '获取企业编号',
  yong_hu_ming_cheng: '用户名称',
  ti_jiao: '提交',
  ding_dan_fen_xi: '订单分析',
  jin_ru_ping_tai: '进入平台',
  yong_hu_shou_ji_hao: '用户手机号',
  que_ding: '确定',
  fei_yong_pei_zhi: '费用配置',
  qing_shu_ru_zhi_fu_gong_zhong_hao: '请输入支付公众号',
  zhong_zhi_cheng_gong: '重置成功',
  qie_huan_zhang_qi: '切换账期',
  dan_tai_she_bei_ping_jun_zhi_zuo_bei_shu: '单台设备平均制作杯数',
  zhi_fu_fang_shi: '支付方式',
  she_bei_lie_biao: '设备列表',
  dian_ji_tong_bu_ji_ke: '点击同步即可',
  dong_hua_suo_hua_fei_de_shi_jian: '动画所花费的时间',
  fen_liao_xiao_yan: '粉料校验',
  dan_wei: '单位',
  yi_chang_shi_jian: '异常时间',
  xuan_qu_pei_fang_zhong_bao_han_de_yin_pin: '选取配方中包含的饮品',
  qing_xuan_qu_kai_shi_gong_zuo_shi_jian: '请选取开始工作时间',
  re_shui_guo_lu_jia_re_chao_shi: '热水锅炉加热超时',
  ci_cao_zuo_jiang_yi_chu_cheng_yuan_yu_bu_men_guan_xi: '此操作将移除成员与部门关系',
  duo_ge_bian_hao_yong_ying_wen_dou_hao: '多个编号用英文逗号',
  cheng_yuan_lie_biao: '成员列表',
  mo_ren_jiao_se: '默认角色',
  qing_shu_ru_jiao_se_ming_cheng: '请输入角色名称',
  she_bei_bang_dan: '设备榜单',
  jin_tian: '今天',
  yin_pin_xin_xi: '饮品信息',
  qing_xuan_qu_she_bei: '请选取设备',
  zuo_biao_zhou_zhi_shi_qi: '坐标轴指示器',
  qing_xian_xuan_qu_ping_bao_tu_pian: '请先选取屏保图片',
  fen_pei_cheng_gong: '分配成功',
  re_shui_guo_li: '热水锅里',
  shang_chuan_cheng_gong: '上传成功',
  cha_kan_cheng_yuan: '查看成员',
  huan_ying_nin: '欢迎您',
  bao_cun: '保存',
  qing_xuan_qu_fu_zhi_she_bei: '请选取复制设备',
  zi_jin_jie_suan_zhi_wei_xin_shang_hu: '资金结算至微信商户',
  jin_ri_xiao_shou_ding_dan: '今日销售订单',
  ci_cao_zuo_jiang_shan_chu_she_bei_zhi_zuo_shi_pin: '此操作将删除设备制作视频',
  ben_yue: '本月',
  pai_xu: '排序',
  ting_ji_she_bei_shu: '停机设备数',
  qing_wan_shan_she_bei_ming_cheng: '请完善设备名称',
  bei_liang: '杯量',
  qing_shu_ru_shang_hu_hao: '请输入商户号',
  jiao_se_pei_zhi: '角色配置',
  zhi_fu_bao_zhi_fu: '支付宝支付',
  xuan_qu_dao_chu_she_bei: '选取导出设备',
  bao_yang_ming_xi: '保养明细',
  yin_pin_ming_cheng: '饮品名称',
  dan_tai_she_bei_ping_jun_cheng_jiao_e: '单台设备平均成交额',
  zhi_fu_she_zhi: '支付设置',
  she_zhi_cheng_gong: '设置成功',
  zuo_tian: '昨天',
  qing_shu_ru_she_bei_ming_cheng: '请输入设备名称/设备IMEI',
  she_bei_chu_shi_hua: '设备初始化',
  niu_nai_xi_tong_qing_xi: '牛奶系统清洗',
  shan_chu_cheng_gong: '删除成功',
  zhi_zuo_bei_shu: '制作杯数',
  qing_xuan_qu_dao_chu_shi_jian: '请选取导出时间',
  tiao_jian_sou_suo: '条件搜索',
  qing_nai_xin_deng_dai: '请耐心等待',
  xuan_qu_she_bei: '选取设备',
  chong_pao_qi_zi_jian: '冲泡器自检',
  shi: '时',
  bian_ma_sou_suo: '编码搜索',
  zan_wei_she_zhi_de_li_wei_zhi: '暂未设置地理位置',
  ce_shi_she_bei: '测试设备',
  ji_fei_xiang_dan: '计费详单',
  ci_cao_zuo_jiang_shan_chu_she_bei_ping_bao: '此操作将删除设备屏保',
  suo_you_she_bei: '所有设备',
  qing_xuan_qu_xu_yao_fen_pei_de_cheng_yuan: '请选取需要分配的成员',
  qing_shu_ru_bu_men_ming_cheng: '请输入部门名称',
  qing_shu_ru_gong_zhong_hao: '请输入公众号',
  ka_fei_dian_re_pan_jia_re_chao_shi: '咖啡电热盘加热超时',
  rang_fu_wu_duan_fan_hui: '让服务端返回',
  yin_pin_zhi_zuo_lie_biao: '饮品制作列表',
  ji_fei_she_bei_shu: '计费设备数',
  ping_xian_guan_li: '屏显管理',
  dao_chu_shu_ju: '导出数据',
  xuan_qu_fen_zu: '选取分组',
  fen_xiang_fa_zi_jian: '分向阀自检',
  zhong_bei_jia_ge: '中杯价格',
  geng_xin_cheng_gong: '更新成功',
  shan_chu_bu_men: '删除部门',
  ji_fei_shu: '计费数',
  nin_de_liu_lan_qi_zan_shi_bu_zhi_chi_shi_pin: '您的浏览器暂时不支持视频',
  qing_shu_ru_cheng_yuan_deng_lu_mi_ma: '请输入成员登录密码',
  huan_jing_wen_du_guo_di: '环境温度过低',
  chan_pin_ming_cheng: '产品名称',
  yin_pin_bian_hao: '饮品编号',
  fu_zhi_yin_pin: '复制饮品',
  xun_huan_zhong_zhi_ji_fei_zhou_qi: '循环重置计费周期',
  cheng_jiao_e: '成交额',
  ding_dan_shi_jian: '订单时间',
  qing_shu_ru_cheng_yuan_ming_cheng: '请输入成员名称',
  cheng_gong: '成功',
  shou_ji_hao: '手机号',
  qing_shu_ru_yuan_gong_deng_lu_mi_ma: '请输入员工登录密码',
  xi_tong_que_shui: '系统缺水',
  bei: '杯',
  cheng_yuan_xin_xi: '成员信息',
  yin_pin_pei_fang: '饮品配方',
  cheng_yuan_ming_cheng: '成员名称',
  ding_yi_guan_jian_zheng: '定义关键帧',
  zheng_qi_dian_re_pan_jia_re_chao_shi: '蒸汽电热盘加热超时',
  she_bei_wei_zhi: '设备位置',
  qing_xi_bei_shu: '清洗杯数',
  qing_xuan_qu_xu_yao_fen_pei_de_she_bei: '请选取需要分配的设备',
  zhi_chi_xiao_shu_dian_hou_liang_wei: '支持小数点后两位',
  suo_you_ding_dan: '所有订单',
  zheng_dian_shi_shi_ding_dan: '整点实时订单',
  ka_fei_dian_re_pan: '咖啡电热盘',
  yi_xuan_yin_pin: '已选饮品',
  qing_shu_ru_shang_chuan_yin_pin_bian_hao: '请输入上传饮品编号',
  shou_ji: '手机',
  lei_ji_ding_dan_jin_e: '累计订单金额',
  huan_bi_zeng_zhang: '环比增长',
  wu_jia_yun_ke_ji_ti_gong_ji_shu_zhi_chi: '五加云科技提供技术支持',
  qie_huan_gong_si: '切换公司',
  ru_guo_bu_jin_xing_tui_kuan_ze_bu_xu_yao: '如果不进行退款则不需要',
  chan_pin: '产品',
  yi_chang_shu_ju: '异常数据',
  ji_xing_fen_bian_lv_shou_ce: '机型分辨率手册',
  kai_shi_fen_xi: '开始分析',
  shou_quan_zheng_shu: '授权证书',
  li_xian_she_bei: '离线设备',
  dian_ji_shang_chuan: '点击上传',
  yuan: '元',
  qing_xian_shang_chuan_yin_pin_tu_pian: '请先上传饮品图片',
  fen_zu_ming_cheng: '分组名称',
  kai_shi_wei_yuan_shi_da_xiao: '开始为原始大小',
  yi_chu_pei_fang_zhong_yin_pin_xin_xi_bu_hui_ying_xiang_yuan_shi_pei_fang_shu_ju: '移除配方中饮品信息不会影响原始配方数据',
  qing_shu_ru_tui_kuan_mi_yao: '请输入退款密钥',
  lei_ji_ding_dan_shu: '累计订单数',
  fen_xiang_fa_yi_chang: '分向阀异常',
  chu_gou: '除垢',
  tong_bu_cheng_gong: '同步成功',
  zhi_fu_ming_cheng: '支付名称',
  she_bei_zhou_qi_ji_fei_shang_xian: '设备周期计费上限',
  fen: '分',
  dou_he_wei_an_zhuang_dao_wei: '豆盒未安装到位',
  yin_pin_ying_wen_ming_cheng: '饮品英文名称',
  qing_kai_shi_she_zhi_xu_yao_shang_chuan_de_yin_pin: '请开始设置需要上传的饮品',
  xin_zeng_wei_hu_she_zhi: '新增维护设置',
  qu_xiao_bang_ding: '取消绑定',
  tian_ru_pei_fang_ming_cheng: '填入配方名称',
  xin_zeng_fen_xi_zu: '新增分析组',
  cheng_jiao_jin_e: '成交金额',
  fen_pei_shi_jian: '分配时间',
  she_bei_zhuang_tai: '设备状态',
  wei_jian_ce_dao_gai_zhang_hu_bang_ding_qi_ye: '未检测到该账户绑定企业',
  xuan_qu_zai_xian_she_bei: '选取在线设备',
  qing_tian_xie_dui_ying_xin_xi: '请填写对应信息',
  qing_xuan_qu_xu_yao_dui_bi_de_fen_zu: '请选取需要对比的分组',
  qing_xuan_qu_she_bei_huo_fen_zu: '请选取设备或分组',
  qing_shu_ru_she_bei_bian_hao: '请输入设备编号',
  wei_bang_ding_jiao_se_yong_hu: '未绑定角色用户',
  pin_ming_jia_zai_zhong: '拼命加载中',
  geng_duo_she_zhi: '更多设置',
  yin_pin_pei_zhi: '饮品配置',
  she_bei_lie_biao_zhong_de_yin_pin_xin_xi_ke_jin_xing_dan_ge_yin_pin_xin_xi_xiu_gai: '设备列表中的饮品信息可进行单个饮品信息修改',
  qing_xuan_ze_zhi_fu_fang_shi: '请选择支付方式',
  qing_xuan_qu_xu_yao_pei_zhi_quan_xian: '请选取需要配置权限',
  she_bei_yi_chang_zeng_zhang_lv_fen_bu: '设备异常增长率分布',
  chuang_jian: '创建',
  zui_jin_yi_zhou: '最近一周',
  jia_zai_she_bei: '加载设备',
  ben_ji_cheng_yuan: '本级成员',
  bu_ke_cao_zuo: '不可操作',
  ding_dan_bian_hao: '订单编号',
  order_number: '系统编号',
  pay_number: '支付编号',
  zhi_zuo_shi_jian: '制作时间',
  yin_pin_ming_chen: '饮品名称',
  yin_pin_bei_liang: '饮品杯量',
  zui_jin_yi_yue: '最近一月',
  zui_jin_san_yue: '最近三月',
  qing_shu_ru_ding_dan_bian_hao: '请输入订单编号',
  dui_bi_fen_xi: '对比分析',
  fen_zu_ming_chen: '分组名称',
  qing_shu_ru_fen_zu_ming_chen: '请输入分组名称',
  qing_shu_ru_she_bei_ming_chen: '请输入设备名称',
  di_li_wei_zhi: '地理位置',
  geng_xin_she_bei_wei_zhi: '更新设备位置',
  xuan_qu_di_li_wei_zhi: '选取地理位置',
  chan_pin_ming_chen: '产品名称',
  she_bei_ming_chen: '设备名称',
  she_bei_suo_ding: '设备锁定',
  pei_fang_ming_cheng: '配方名称',
  tong_bu_yin_ping_pei_fang: '同步饮品配方',
  shan_chu_pei_fang: '删除配方',
  yi_chu: '移除',
  xin_zeng_tong_bu_she_bei: '新增同步设备',
  zai_xian_she_bei_lie_biao: '在线设备列表',
  guan_lian_she_bei: '关联设备',
  tong_bu_cao_zuo_shuo_ming: '同步操作说明',
  qing_shu_ru_pei_fang_ming: '请输入配方名称',
  qing_xuan_qu_yin_pin: '请选取需要同步的饮品',
  fa_sheng_shi_jian: '发生时间',
  hui_fu_zheng_chang: '恢复正常',
  fa_sheng_yi_chang: '发生正常',
  xuan_qu_device: '选取所需导出设备',
  quan_xuan: '全选',
  logo_bian_ji: 'LOGO编辑',
  tip_logo: '限制分辨率参考机型分辨率手册,上传后立即修改LOGO',
  drag_file: '将文件拖到此处，或点击上传',
  add_ali_pay: '新增支付宝支付',
  add_wx_pay: '新增微信支付',
  reload_pay: '重载支付信息',
  wechat_pay_tip: '资金结算至微信商户，交易手续费由微信收取',
  wechat_pay_tip_remark: '(微信内不可使用支付宝)',
  ali_pay_tip: '资金结算至支付宝商户，交易手续费由支付宝收取(支付宝内不可使用微信)',
  ali_pay_tip_remark: '(支付宝内不可使用微信)',
  remark_wechat_config: '配置支付之前请先联系系统管理人员',
  t_500865ef2001000: '首页',
  t_500985da1401000: '对比分析',
  t_50083b154801000: '研发管理',
  t_50084945b801000: '设备管理',
  t_50084a5d9401000: '经销商管理',
  t_50084b33a001000: '系统设置',
  t_50085d8eb001000: '经销商首页',
  t_500867b84801000: '成员管理',
  t_50086895bc01000: '订单管理',
  t_500869810c01000: '设备管理',
  t_50086a34e001000: '系统设置',
  t_50088bc26001000: '系统管理',
  t_50086cbb4c01000: '组织架构',
  t_50086f4e0001000: '成员列表',
  t_50087496d401000: '订单分析',
  t_500876e1a401000: '制作清单',
  t_50087b146c01000: '设备列表',
  t_50087d152001000: '屏显管理',
  t_50087ea47001000: '饮品管理',
  t_500880105001000: '维护设置',
  t_5008847d6c01000: '费用清单',
  t_500885da1401000: '数据分析',
  t_50088a319801000: '支付设置',
  t_500891a83001000: '基础系统',
  t_5008936e7c01000: '模块管理',
  t_5008f30d3401000: '角色配置',
  t_55be408fd001000: '告警列表',
  t_55d2b4167c01000: '异常告警',
  t_563a1a536801000: '数据导出',
  t_500841ad6401000: '异常库',
  t_500843637c01000: '版本库',
  t_5008453b5001000: '产品库',
  t_500850925401000: '设备列表',
  t_50085288b001000: '经销商列表',
  t_5523bc9d8001000: '蓄水盘未安装到位',
  t_5523bca5f401000: '容渣盒已满',
  t_5523bcae6401000: '水箱缺水',
  t_5523bcb74001000: '蓄水盘水满',
  t_5523bcbfb401000: '桶装水缺水',
  t_5523bcc85801000: '废水桶水满',
  t_5523bcd0c001000: '冲泡器未安装到位',
  t_5523bcd97c01000: '门未关闭到位',
  t_5523bce1f401000: '豆盒1未安装到位',
  t_5523bcea5801000: '豆盒2未安装到位',
  t_5523bcf33001000: '豆盒3未安装到位',
  t_5523bcfbec01000: '豆盒1缺豆',
  t_5523bd04c801000: '豆盒2缺豆',
  t_5523bd0d6801000: '豆盒3缺豆',
  t_5523bd160001000: '粉料盒1未安装到位',
  t_5523bd1ed801000: '粉料盒2未安装到位',
  t_5523bd277001000: '粉料盒3未安装到位',
  t_5523bd301001000: '粉料盒1缺粉',
  t_5523bd38c401000: '粉料盒2缺粉',
  t_5523bd416401000: '粉料盒3缺粉',
  t_5523bd4a2401000: '研磨机校验',
  t_5523bd52e401000: '咖啡机需要除垢',
  t_5523bd5b9001000: '冲煮系统需要清洗',
  t_5523bd645801000: '冲泡器需要清洁',
  t_5523bd6d0001000: '牛奶系统需要清洗',
  t_5523bd75b401000: '粉料系统需要清洗',
  t_5523bd7e6001000: '牛奶温度过低',
  t_5523bd86f801000: '牛奶温度过高',
  t_5523bd8fc001000: '牛奶不足',
  t_5523bd9d5c01000: '牛奶盒未安装',
  t_5523bda5f401000: '系统缺水',
  t_5523bdaee401000: '系统压力过大',
  t_5523bdb79401000: '冲泡器自检',
  t_5523bdc5f801000: '分向阀自检',
  t_5523bdd00401000: '环境温度过高',
  t_5523bdd8f801000: '环境温度过低',
  t_5523bde1ac01000: '咖啡锅炉温度过高',
  t_5523bdeab801000: '蒸汽锅炉温度过高',
  t_5523bdf37801000: '热水锅炉温度过高',
  t_5523bdfc1801000: '咖啡锅炉温度过低',
  t_5523be04d801000: '蒸汽锅炉温度过低',
  t_5523be0da001000: '热水锅炉温度过低',
  t_5523be164801000: '系统补水超时',
  t_5523be1ee401000: 'HMI通信异常',
  t_5523be277c01000: '咖啡锅炉加热超时',
  t_5523be304401000: '蒸汽锅炉加热超时',
  t_5523be392001000: '热水锅炉加热超时',
  t_5523be41dc01000: '咖啡锅炉NTC异常',
  t_5523be4abc01000: '蒸汽锅炉NTC异常',
  t_5523be536c01000: '热水锅炉NTC故障',
  t_5523be5c1801000: '咖啡锅炉供水故障',
  t_5523be64b401000: '蒸汽锅炉供水故障',
  t_5523be6d6001000: '热水锅炉供水故障',
  t_5523be760c01000: '冲煮系统异常',
  t_5523be7efc01000: '分向阀系统异常',
  t_5523be880c01000: '磨豆机1异常',
  t_5523be95f001000: '磨豆机2异常',
  t_5523be9eac01000: '磨豆机3异常',
  t_5523beac5801000: '冰箱通信异常',
  t_512885da1401000:'物料分析',
  language: '中文',
  forget_password_tip: '忘记密码请联系管理员进行修改',
  unbind_enterprise: '未检测到该账户绑定企业',
  complete_info: '请填写完整信息',
  TB_tip: '技术助力商业发展',
  login_entry: '系统登录',
  huan_ying_shi_yong: '欢迎使用',
  shi_fou_jie_bang_she_bei: '是否解绑设备',
  a_group: '对比分组A',
  b_group: '对比分组B',
  company_number: '公司编号',
  safe_quit: '安全退出',
  welcome_to_you: '欢迎您',
  empty_info: '这里空空如也，可通过页面进行添加操作',
  fill_payment_name: '请填写支付名称后点击下方',
  createAuthorizedQrCode: '创建授权二维码',
  produceAuthorizedQrCode: '产生授权二维码',
  payAuth: '支付授权',
  lookPayProgress: '查看申请进度',
  status: '申请状态',
  applying: '申请中',
  fail: '申请失败',
  success: '申请成功',
  wechatScanSureAuth: '请用超级管理员微信扫描，完成签约确认',
  applyFail: '申请失败',
  delete_pay_info: '此操作将删除支付信息，是否继续',
  su_zhou_nong_hang: '苏州农行',
  queryAliStatus: '查看授权码',
  delete_device_alarm_info: '删除设备将导致设备历史数据不可见，是否继续',
  wu_liao_fen_xi:'物料分析',
  ka_fei_dou_shu:'咖啡豆克重',
  ke:'克',
  nai_mo_liang:'奶沫量',
  hao_sheng:'毫升',
  nai_gai_liang:'奶盖量',
  jin_30_tian_wu_liao_xiao_hao:'近30天物料消耗',
  niu_nai_liang:'牛奶量',
  shu_liang:'数量',
  dao_chu: '导出',
  fen_liao_ke_zhong:'粉料克重',
  tong_bu_she_bei_yin_pin_pei_fang:'同步设备饮品配方',
  yin_pin_xin_xi:'饮品信息',
  xiao_bei_jia_ge_yuan:'小杯价格(元)',
  zhong_bei_jia_ge_yuan:'中杯价格(元)',
  da_bei_jia_ge_yuan:'大杯价格(元)',
  pai_xu_yue_xiao_yue_kao_qian:'排序(越小越靠前)',
  ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_pei_fang_zhi_yun_duan:'此操作将全量拉取设备饮品配方至云端, 是否继续?',
  geng_xin_shi_jian:'更新时间',

}
